<template>
    <tr>
        <td>{{label}}</td>
        <td>
            <div class="flex-grid flex-grid--reduced-bottom-margin" name="value">
                <div class="flex-grid__g-7">
                    <input autocomplete="off" v-field-control
                           v-model="value"
                           type="number"
                           required
                           min="0.00"
                           name="value">
                    <control-error :show="$error('value') && include">
                        {{ label }} is required and must be greater than £0.00
                    </control-error>
                </div>
                <div class="flex-grid__g-3"></div>
            </div>
        </td>
        <td>
            <select v-model="include">
                <option :value="true">Yes</option>
                <option :value="false">No</option>
            </select>
        </td>
    </tr>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import ControlError from 'components/form/control/Error.vue';
    import FormValidator from 'components/form/validator/mixin';
    import { setStepValid }  from 'services/routingMethods';
    export default {
        name: 'benefit',
        props: {
            label: String,
            cruKey: {
                type: String,
                required: true
            }
        },
        mixins: [
            FormValidator
        ],
        components: {
            ControlError
        },
        computed: {
            ...mapGetters('fatal/cru', {
                findValue: 'value',
                findInclude: 'include',
                allValid: 'allValid'
            }),
            value: {
                get(){
                    return this.findValue(this.cruKey);
                },
                set(value) {
                    this.updateValue({key: this.cruKey, value}).then(()=>{
                        this.include = !!value;
                        this.updateValid();
                        this.calcAllInterest();
                    });
                }
            },
            include: {
                get(){
                    return this.findInclude(this.cruKey);
                },
                set(value) {
                    this.updateInclude({key: this.cruKey, value})
                        .then(
                            this.updateValid(),
                            this.calcAllInterest()
                        );
                }
            }
        },
        methods: {
            ...mapActions('fatal/cru', ['updateValue', 'updateInclude']),
            ...mapActions('fatal/headsOfLoss', ['calcAllInterest']),
            updateValid(){
                setStepValid(this.allValid);
            },
            calcValue(){
                this.calcAllInterest;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Benefit.vue?cf1533dc